/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
import Vue from 'vue';
import Profile from './Profile';
import ProfileForm from './ProfileForm';
import EntityHome from './EntityHome';
import EntityCreate from './EntityCreate';
import EntityEdit from './EntityEdit';
import SearchUpdate from './SearchUpdate.vue';
import SearchesHome from './SearchesHome';
import SearchEdit from './SearchEdit';
import EntityImport from './EntityImport';
import EntityExport from './EntityExport';
import UbermetricsAccountCountings from './UbermetricsAccountCountings.vue';
import SearchCreate from './SearchCreate';
import OrphanedSearches from './OrphanedSearches';
import ImportsHome from './ImportsHome';
import ImportView from './ImportView';
import EventRegexHome from "./EventRegexHome";
import EventRegexCreate from "./EventRegexCreate";
import EventRegexEdit from "./EventRegexEdit";
import TagChange from "./TagChange";
import Login from "./Login";

Vue.component('profile-form', ProfileForm);

export {
  Profile,
  ProfileForm,
  EntityCreate,
  EntityEdit,
  EntityHome,
  SearchUpdate,
  SearchesHome,
  SearchEdit,
  EntityImport,
  EntityExport,
  UbermetricsAccountCountings,
  SearchCreate,
  OrphanedSearches,
  ImportsHome,
  ImportView,
  EventRegexHome,
  EventRegexCreate,
  EventRegexEdit,
  TagChange,
  Login
};
